<template>
  <transition-fade :duration="200">
    <div
      v-if="show"
      :class="['bg-black/24 fixed inset-0 z-20 overflow-y-auto', $style.uiLightboxBackdrop]"
      role="button"
      tabindex="0"
      @click="closeModal"
      @keyup.enter.exact="closeModal"
      @keyup.space.exact="closeModal"
    >
      <dialog
        class="absolute inset-0 m-auto flex h-4/5 w-4/5 flex-col items-center justify-center border-none bg-transparent outline-none"
        tabindex="-1"
      >
        <global-events no-filtering @keyup.esc="closeModal" />
        <div class="relative flex max-h-full max-w-full justify-center bg-transparent outline-none" @click.stop>
          <img
            :src="src"
            alt="image"
            :class="['mx-auto max-h-full max-w-full rounded-md object-contain shadow-2xl', $style.uiLightboxImg]"
          />
          <button
            class="text-gray-80 bg-gray-20 absolute -right-12 top-0 flex h-8 w-8 items-center justify-center rounded-xl outline-none transition-colors duration-300 hover:bg-white"
            type="button"
            @click="closeModal"
          >
            <x-icon class="icon-m" />
          </button>
          <a
            :href="src"
            target="_blank"
            rel="noreferrer noopener"
            class="text-gray-80 bg-gray-20 absolute -right-12 bottom-0 flex h-8 w-8 items-center justify-center rounded-xl outline-none transition-colors duration-300 hover:bg-white"
          >
            <external-link-icon class="icon-m" />
          </a>
        </div>
      </dialog>
    </div>
  </transition-fade>
</template>

<script lang="ts" setup>
import { defineComponent, nextTick, ref, watch } from 'vue'
import { TransitionFade } from '@morev/vue-transitions'
import { XIcon, ExternalLinkIcon } from '@klausapp/ui-kit/icons'
import { GlobalEvents } from '@klausapp/ui-kit'

const props = defineProps<{
  show: boolean
  src: string
}>()

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'focus'): void
}>()

defineComponent({
  name: 'UiLightbox',
})

const dialog = ref<HTMLDialogElement | null>(null)

const closeModal = () => {
  emit('close')
}

watch(
  () => props.show,
  async (val) => {
    if (val) {
      await nextTick()
      dialog.value?.focus()
      emit('focus')
    }
  },
)
</script>

<style lang="scss" module>
.uiLightboxImg {
  animation: image-fade-in 0.08s ease-out;
}

.uiLightboxBackdrop {
  backdrop-filter: blur(12px);
}

@keyframes image-fade-in {
  0% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}
</style>
